<template>
  <div class="xm-search-box">
    <slot></slot>
  </div>
</template>
<script>
export default {

}
</script>
<style lang="scss" scoped>
.xm-search-box {
  margin-top: 10px;
  :deep .el-select {
    margin-right: 20px;
  }
}
</style>
